import { useListStore } from '../../hooks';
import { ApiKeyTemplateListView } from '../../components/ApiKeyTemplateListView';

export const ApiKeyTemplateList = () => {
  const { apiKeyTemplates, onOpenModal } = useListStore();

  return (
    <ApiKeyTemplateListView
      listItems={apiKeyTemplates}
      handleEditOpenModal={onOpenModal}
    />
  );
};
